/*
 * Copyright (c) CIRROM 2023.
 */

import LinearProgress from "@mui/material/LinearProgress";
import React from "react";

/**
 * A logo to show that something is happening in the Cirrom server

 */
export const CirromLoadingLogo = (props: { iconHeight?: string }) => {
  return (
    <div>
      <img
        alt="LogoSm"
        src="/Cirrom_Logo_Yellow_Background.svg"
        style={{ height: props.iconHeight || "50px" }}
      />
      <LinearProgress />
    </div>
  );
};
